import React, { useContext } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { PartnerAuthState } from 'stores/PartnerAuthStore';
import * as PAGE_URL from './PageUrl';

function AuthRoute({
  pathValid,
  component: Component,
  ...rest
}: any): React.ReactElement {
  const { partnerUserDocStatus, service } = useContext(PartnerAuthState);
  const accessToken = localStorage.getItem('access-token');
  let redirectPath = '';

  if (accessToken) {
    // 로그인 상태에서 로그인 | 회원가입 | 메인으로 들어오면 서비스 선택 페이지로
    if (
      rest.path === PAGE_URL.LOGIN.path ||
      rest.path === PAGE_URL.SIGNUP.path ||
      rest.path === '/'
    ) {
      redirectPath = PAGE_URL.SERVICE_SELECT.url;
    } else {
      //const partnerInfoData: IPartnerAuthState = JSON.parse(partnerInfo);
      const serviceType = rest.computedMatch.params.serviceType;
      let partnerService;
      // 서비스 타입이 math param으로 넘어오면 해당 서비스를 파트너 정보에서 가져와서 비교한다.
      if (serviceType) {
        partnerService = service.find(
          (service) =>
            service.serviceType ===
            (serviceType === 'smallmove'
              ? 'small_move'
              : serviceType === 'familymove'
              ? 'family_move'
              : 'move_cleaning')
        );
      } else {
        if (
          [
            PAGE_URL.SMALLMOVE_INFO.path,
            PAGE_URL.SMALLMOVE_REGISTER.path,
            PAGE_URL.SMALLMOVE_CARINFO_REGISTER.path,
          ].includes(rest.path)
        ) {
          partnerService = service.find(
            (service) => service.serviceType === 'small_move'
          );
        } else if (
          [
            PAGE_URL.FAMILYMOVE_INFO.path,
            PAGE_URL.FAMILYMOVE_REGISTER.path,
            PAGE_URL.FAMILYMOVE_CARINFO_REGISTER.path,
          ].includes(rest.path)
        ) {
          partnerService = service.find(
            (service) => service.serviceType === 'family_move'
          );
        } else if (
          [
            PAGE_URL.MOVECLEANING_INFO.path,
            PAGE_URL.MOVECLEANING_REGISTER.path,
            PAGE_URL.MOVECLEANING_PROFILE_REGISTER.path,
          ].includes(rest.path)
        ) {
          partnerService = service.find(
            (service) => service.serviceType === 'move_cleaning'
          );
        } else {
          partnerService = null;
        }
      }

      if (partnerService && partnerUserDocStatus) {
        if (pathValid.partnerUserDocStatus) {
          if (!pathValid.partnerUserDocStatus.includes(partnerUserDocStatus)) {
            alert('접근 불가능한 상태입니다.');
            redirectPath = PAGE_URL.SERVICE_SELECT.url;
          }
        }

        if (pathValid.serviceDocStatus || pathValid.serviceActiveStatus) {
          if (
            !pathValid.serviceDocStatus.includes(
              partnerService.serviceDocStatus
            ) ||
            !pathValid.serviceActiveStatus.includes(
              partnerService.serviceActiveStatus
            )
          ) {
            alert('접근 불가능한 상태입니다.');
            redirectPath = PAGE_URL.SERVICE_SELECT.url;
          }
        }
      }
    }
  } else {
    if (pathValid.requiredLogin) {
      alert('로그인이 필요한 서비스입니다.');
      redirectPath = PAGE_URL.LOGIN.url;
    }
  }

  return (
    <Route
      {...rest}
      render={(props: any) => {
        return redirectPath ? (
          <Redirect to={redirectPath} />
        ) : (
          <Component {...props} />
        );
      }}
    />
  );
}

export default AuthRoute;
